<template>
  <div>
    <el-card>
      <div class="dashboard-header">
        <div class="left-header">
          <h1>This Week</h1>
        </div>
        <!-- eo left header -->

        <div class="right-dates">
          <h1>
            <span class="day">{{ date }}</span>
          </h1>
        </div>
        <!-- eo right dates -->
      </div>

      <div class="dashboard-content">
        <div class="dashboard-detail">
          <div class="dashboard-box total-missedcall">
            <h1>{{ total }}</h1>
            <p>Total Engagement</p>
          </div>

          <div class="dashboard-box returning-customers">
            <h1>{{ unique }}</h1>
            <p>Unique Engagement</p>
          </div>
        </div>

        <div class="graph">
          <kendo-chart
            ref="chart"
            :legend-position="'bottom'"
            :chart-area-background="''"
            :chart-area-height="'248px'"
            :series-defaults-type="'line'"
            :series-defaults-style="'smooth'"
            :value-axis-labels-format="'{0}'"
            :value-axis-line-visible="false"
            :value-axis-axis-crossing-value="'-10'"
            :category-axis-categories="categories"
            :category-axis-major-grid-lines-visible="false"
            :category-axis-labels-rotation="'auto'"
            :tooltip-visible="true"
            :tooltip-format="'{0}'"
            :tooltip-template="tooltiptemplate"
            :theme="'sass'"
          >
            <kendo-chart-series-item
              :name="'Missed Calls'"
              :data="weeklyMissedCallData"
            ></kendo-chart-series-item>
          </kendo-chart>
        </div>
        <!-- eo dashboard graph -->
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";
import { getmissedcallcount, getHeader } from "./../../../config";

export default {
  data: function() {
    return {
      date: "",
      total: "",
      unique: "",
      tooltiptemplate: "#= series.name #: #= value #",
      weeklyMissedCallData: [],
      categories: []
    };
  },
  mounted() {
    axios.get(getmissedcallcount, { headers: getHeader() }).then(Response => {
      // console.log(Response.data.data.weekly.periods)
      this.categories = Response.data.data.weekly.periods.dates;
      this.weeklyMissedCallData = Response.data.data.weekly.periods.counts;
      this.total = Response.data.data.weekly.total;
      this.unique = Response.data.data.weekly.unique;
      this.date = Response.data.data.weekly.date;
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/parts/dashboardweek.vue